import React from 'react';
import PropTypes from 'prop-types';

class Qualification extends React.Component {
    render() {
        const { qualification, isLoading } = this.props;

        if (isLoading || !qualification) {
            return null;
        }

        // Il faut éventuellement ajouter un format.

        return qualification.libelle;
    }
}

Qualification.propTypes = {
    qualification: PropTypes.object,
    isLoading: PropTypes.bool.isRequired
};

export default Qualification;